export const imageToUrl = (path: string) => {
  if (path.includes('http') || path.includes('data:image'))
    return path
  return `${process.env.REACT_APP_URL_IMAGE}/${path}`
}
